module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_scheda-edcd762281596f66309d63d10e1f297e.svg";